import * as React from 'react';
import { Form } from 'react-bootstrap';

export interface SelectListProps {
  onChange?: (event: any) => void;
  value: string;
  data: any[];
  className?: string;
  placeholder?: string;
  datafield?: string;
  title?: string;
  name?: string;
  tabindex?: number;
  disabled?: boolean;
}

export default class SelectList extends React.Component<SelectListProps, any> {
  public render() {
    const {
      onChange,
      value,
      data,
      className,
      placeholder,
      datafield,
      title,
      name,
      tabindex,
      disabled
    } = this.props;
    return (
      <Form.Control
        title={title ? title : ''}
        name={name ? name : ''}
        as='select'
        onChange={(e) => onChange(e)}
        value={value}
        className={className}
        data-field={datafield}
        tabIndex={tabindex}
        disabled={disabled}
      >
        {placeholder && (
          <option key='-1' value='-1'>
            {placeholder}
          </option>
        )}
        {data &&
          data.map((x, idx) => (
            <option key={idx} value={x.value}>
              {x.name}
            </option>
          ))}
      </Form.Control>
    );
  }
}
